import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    background: #fff;

    & .header {
      height: 110px;
      @media screen and (orientation: portrait) {
        height: 60px;
      }
    }
  }
`;

export const BlogContent = styled.section `
  display: flex;
  padding: 20px;
  padding-bottom: 50px;
  padding-top: 114px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;

  & .footer {
    margin-top: 250px;
    @media screen and (orientation: portrait) {
      margin-top: 35px;
    }
  }

  @media screen and (orientation: portrait) {
    padding: 0;
    padding-bottom: 30px;
    padding-top: 80px;
  }
`;

export const ArticleWrap = styled.div `
  width: 100%;
  max-width: 1600px;

  & h1 {
    width: 100%;
    max-width: 850px;
    text-align: center;
    color: #000;
    font-size: 40px;
    font-weight: 900;
    line-height: 45px;
    text-transform: uppercase;
    margin-bottom: 20px;
    letter-spacing: 2px;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #000;
    @media screen and (orientation: portrait) {
      font-size: 30px;
      line-height: 33px;
    }
  }

  & > .onScrollTopMenu {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  & > .onScrollBottomMenu {
    position: fixed;
    width: 100%;
    left: 0;
    top: 85px;
    background: #fff;
    z-index: 10;
    padding: 12px;
    padding-top: 0;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (orientation: portrait) {
      top: 55px;
      padding: 0;
    }

    & > h1 {
      max-width: 600px;
      line-height: 33px;
      font-size: 25px;
      margin-bottom: 0;
      font-weight: 600;
      transition: .4s;
      @media screen and (orientation: portrait) {
        max-width: 345px;
      line-height: 27px;
        font-size: 18px;
        font-weight: 500;
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: #000;
      }
    }
  }

  & > .collectionWrap {
    max-width: 1300px;
    width: 100%;
    position: relative;
    margin: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;
    row-gap: 20px;
    margin-bottom: 50px;

    & .imgWrap {
      position: relative;

      & > img {
        width:100%;
        height: auto;
        @media screen and (orientation: portrait) {
          max-width: 100%;
        }
      }
      & > span {
        position: absolute;
        width: 40px;
        height: 40px;
        // bottom: 180px;
        bottom: 20px;
        left: 20px;
        background: #000;
        font-size: 20px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }

      & > a {
        position: absolute;
        width: 160px;
        height: 35px;
        bottom: -10px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        background: #000;
        font-size: 15px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
        @media screen and (orientation: portrait) {
          height: 40px;
          bottom: 20px;
          left: 20px;
          right: auto;
          margin-left: 0;
          margin-right: 0;
        }
      }
    }

    & .invest_board {
      width: 100%;
      padding-top: 10px;
      padding-bottom: 20px;
      display: flex;
      flex-direction: column;
      row-gap: 15px;
      box-sizing: border-box;

      & > .btn {
        width: max-content;
        height: 33px;
        border-radius: 50px;
        border: 1px solid #ddd;
        background: #000;
        color: #fff;
        text-align: center;
        font-family: "Inconsolata", serif;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.77px;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding-left: 15px;
        padding-right: 15px;
      }

      @media screen and (orientation: portrait) {
        padding-left: 15px;
        padding-right: 15px;
        row-gap: 10px;
      }
    }
    
    @media screen and (orientation: portrait) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 7px;
      row-gap: 7px;
      margin-bottom: 0;
    }
  }

  @media screen and (orientation: portrait) {
    max-width: 100%;
  }
`;

export const MenuWrap = styled.div`
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  @media screen and (orientation: portrait) {
    border: 0;
    padding: 0;
    display: none;
  }
`;

export const ArticlesContent = styled.div`
  position: relative;
  width: 100%;
  padding-top: 80px;
  box-sizing: border-box;
  @media screen and (orientation: portrait) {
    padding-top: 0;
  }
`;

export const ArticleHhightlight = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 60px;

  & > .titleWrap {
    position: relative;
    width: 100%;
    max-width: 750px;
    display: flex;
    align-items: center;
    height: 82px;

    & > div {
      position: absolute;
      top: 0;
      left: 112px;
      height: 100%;
      background: #fff;
      padding-left: 16px;
      padding-right: 40px;
      box-sizing: border-box;

      & > .top_title {
        color: #000;
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0.84px;
        text-transform: uppercase;
        @media screen and (orientation: portrait) {
          font-size: 11px;
        }
      }

      & > h2 {
        color: #000;
        text-align: center;
        font-family: Buda;
        font-size: 32px;
        font-weight: 300;
        line-height: 41px;
        letter-spacing: 2.24px;
        text-transform: uppercase;
        @media screen and (orientation: portrait) {
          font-size: 25px;
          text-align: left;
          line-height: 25px;
        }
      }

      & > .collection {
        color: #000;
        text-align: center;
        font-family: Roboto;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0.98px;
        text-transform: uppercase;
        @media screen and (orientation: portrait) {
          font-size: 11px;
        }
      }
      @media screen and (orientation: portrait) {
        position: relative;
        width: 100%;
        left: 0;
      }
    }

    &::after {
      content: "";
      width: 100%;
      height: 1px;
      background: #000;
      display: block;
      @media screen and (orientation: portrait) {
        display: none;
      }
    }

    @media screen and (orientation: portrait) {
      position: initial;
      max-width: 100%;
      height: auto;
    }
  }

  & > .mediaContent {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @media screen and (orientation: portrait) {
      flex-direction: column;
    }

    & a {
      & > svg {
        position: absolute;
        left: 40%;
        top: auto;
        cursor: pointer;
        z-index: 1;
        @media screen and (orientation: portrait) {
          left: auto;
          top: 12%;
        }
      }
      @media screen and (orientation: portrait) {
        width: 55px;
      }
    }

    & > video {
      width: 72%;
      height: auto;
      object-fit: cover;
      @media screen and (orientation: portrait) {
        width: 100%;
      }
    }

    & > .descContent {
      position: absolute;
      right: 0;
      bottom: -66px;
      width: 100%;
      max-width: 694px;
      background: #fff;
      padding-top: 45px;
      padding-bottom: 29px;
      padding-left: 34px;
      padding-right: 34px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 1;
      @media screen and (orientation: portrait) {
        bottom: 0;
        padding-top: 23px;
        padding-bottom: 23px;
        padding-left: 20px;
        padding-right: 20px;
      }

      & > h2 {
        width: 100%;
        max-width: 500px;
        color: #000;
        font-size: 36px;
        font-style: normal;
        font-weight: 900;
        line-height: 40px;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-bottom: 30px;
        text-align: center;
        &:first-of-type {
          margin-bottom: 0;
        }
        @media screen and (orientation: portrait) {
          font-size: 24px;
          margin-bottom: 19px;
          line-height: 30px;
        }
      }

      & > p {
        color: #000;
        font-family: "Inconsolata", serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 1.56px;
        margin-bottom: 40px;
        @media screen and (orientation: portrait) {
          margin-bottom: 30px;
          line-height: 18px;
        }
      }

      & > span {
        & > a {
          color: #000;
          font-family: "Inconsolata", serif;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 30px;
          letter-spacing: 1.44px;
          text-decoration-line: underline;
          text-transform: uppercase;
        }
      }

      & > a {
        display: block;
        width: 182px;
        height: 35px;
        color: #fff;
        text-align: center;
        font-family:"Inconsolata", serif;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 1.32px;
        border-radius: 50px;
        border: 1px solid #DDD;
        background: #000;
        text-decoration: none;
        margin-top: 25px;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (orientation: portrait) {
          position: relative;
          margin: 25px auto 0;
        }
      }

      @media screen and (orientation: portrait) {
        position: relative;
        max-width: 100%;
        left: 0;
      }
    }

    & > .descContentBreaking {
      position: absolute;
      left: 0;
      top: auto;
      width: 100%;
      max-width: 540px;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 1;
      @media screen and (orientation: portrait) {
        bottom: 0;
        padding-top: 23px;
        padding-bottom: 23px;
        padding-left: 20px;
        padding-right: 20px;
      }

      & > h2 {
        width: 100%;
        max-width: 500px;
        color: #000;
        font-size: 32px;
        font-style: normal;
        font-weight: 900;
        line-height: 40px;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-bottom: 30px;
        text-align: center;
        &:first-of-type {
          margin-bottom: 0;
        }
        @media screen and (orientation: portrait) {
          font-size: 24px;
          margin-bottom: 19px;
          line-height: 30px;
        }
      }

      & > p {
        color: rgba(0,0,0, 0.6);
        font-family: "Inconsolata", serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px; /* 230.769% */
        letter-spacing: 1.56px;
        margin-bottom: 40px;
        @media screen and (orientation: portrait) {
          margin-bottom: 30px;
        }
      }

      & > span {
        & > a {
          color: #000;
          font-family: "Inconsolata", serif;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 30px;
          letter-spacing: 1.44px;
          text-decoration-line: underline;
          text-transform: uppercase;
        }
      }

      & > div {
        display: flex;
        column-gap: 20px;
        @media screen and (orientation: portrait) {
          flex-direction: column;
          column-gap: 0;
          row-gap: 10px;
        }
      }

      & a {
        display: block;
        width: 182px;
        height: 35px;
        color: #fff;
        text-align: center;
        font-family: "Inconsolata", serif;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 1.32px;
        border-radius: 50px;
        border: 1px solid #DDD;
        background: #000;
        text-decoration: none;
        margin-top: 25px;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (orientation: portrait) {
          position: relative;
          margin: 25px auto 0;
        }
      }
      @media screen and (orientation: portrait) {
        position: relative;
        max-width: 100%;
        left: 0;
      }
    }
  }

  & > .mediaContentRW {
    margin-top: 150px;
    bottom: 0;
  }
  @media screen and (orientation: portrait) {
    padding-bottom: 0;
    row-gap: 12px;
  }
`;

export const TitleDesigner = styled.div`
    width: 100%;
    max-width: 440px;
    height: 68px;
    background: #fff;
    margin-top: 220px;
    padding-left: 16px;
    margin-bottom: 30px;

    & > span {
      display: block;
      color: #000;
      font-family: "Inconsolata", serif;
      font-size: 11px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.77px;
      text-transform: uppercase;
      padding-top: 6px;
      padding-bottom: 10px;
    }

    & > h2 {
      color: #000;
      font-family: Buda;
      font-size: 32px;
      font-weight: 300;
      line-height: 22px;
      letter-spacing: 2.24px;
      text-transform: uppercase;
    }
    @media screen and (orientation: portrait) {
      max-width: 100%;
      padding-bottom: 7px;
      box-sizing: border-box;
      margin-top: 180px;
      margin-bottom: 0;
    }
`;

export const SmallBlock = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 6%;
  row-gap: 194px;
  margin-bottom: 137px;
  &::last-of-type {
    margin-bottom: 0;
  }
  @media screen and (orientation: portrait) {
    display: flex;
    padding: 15px;
    padding-top: 23px;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 206px;
    margin-bottom: 230px;
  }
`;

export const MediumBlock = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 7.5%;
  row-gap: 227px;
  &::last-of-type {
    margin-bottom: 0;
  }
  @media screen and (orientation: portrait) {
    display: flex;
    padding: 15px;
    padding-top: 23px;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 150px;
  }
`;

export const MediumBlockAfter = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 7.5%;
  row-gap: 227px;
  margin-top: 220px;
  &::last-of-type {
    margin-bottom: 0;
  }
  @media screen and (orientation: portrait) {
    display: flex;
    padding: 15px;
    padding-top: 23px;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 150px;
    margin-top: 140px;
  }
`;

export const MediumBlockBreaking = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 7.5%;
  row-gap: 227px;
  margin-top: 50px;
  &::last-of-type {
    margin-bottom: 0;
  }
  @media screen and (orientation: portrait) {
    display: flex;
    padding: 0;
    padding-top: 23px;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 30px;
    margin-top: 0;
  }
`;

export const MediumBlockBreakingAfter = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 7.5%;
  row-gap: 227px;
  margin-top: 170px;
  @media screen and (orientation: portrait) {
    display: flex;
    padding: 0;
    padding-top: 23px;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 30px;
    margin-top: 85px;
  }
`;

export const ModalVideo = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fafafa;
  z-index: 10;

  & > div {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url('/assets/backvideo.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 110;
  }

  & > video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
`;

export const SmallTitle = styled.span`
  position: relative;
  font-size: 15px;
  font-weight: 700;
  // text-transform: uppercase;
  color: #000;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  margin-top: 50px;
  &::before {
    content: '';
    position: absolute;
    width: 120px;
    height: 2px;
    background: #000;
    bottom: -5px;
    left: auto;
    margin-left: -66px;
  }
`;

export const SmallTitleAfter = styled.span`
  position: relative;
  font-size: 15px;
  font-weight: 700;
  // text-transform: uppercase;
  color: #000;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  margin-top: 245px;
  margin-bottom: -116px;
  @media screen and (orientation: portrait) {
    margin-top: 40px;
    margin-bottom: -79px;
  }
  &::before {
    content: '';
    position: absolute;
    width: 120px;
    height: 2px;
    background: #000;
    bottom: -5px;
    left: auto;
    margin-left: -66px;
  }
`;

export const CollectionTitle = styled.div`
  position: absolute;
  width: 100%;
  top: 50px;
  left: 0;
  display: flex;
  justify-content: center;

  & > span {
    font-size: 15px;
    font-weight: 700;
    color: #000;
    letter-spacing: 1px;
    // text-transform: uppercase;
  }

  @media screen and (orientation: portrait) {
    position: relative;
    top: 0;
    margin-bottom: 15px;

    & > span {
      font-size: 14px;
    }
  }
`;

export const BlogSection = styled.section `
  display: flex;
  padding: 20px;
  padding-bottom: 50px;
  padding-top: 114px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;

  & .footer {
    margin-top: 50px;
    @media screen and (orientation: portrait) {
      margin-top: 35px;
    }
  }

  @media screen and (orientation: portrait) {
    padding: 0;
    padding-bottom: 30px;
    padding-top: 80px;
  }
`;

export const BlogWrapContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 700px;
  margin: auto;
  margin-top: 50px;
  box-sizing: border-box;

  & > h2, h3 {
    width: 100%;
    font-weight: 800;
  }

  & > h2 {
    text-align: left;
    font-size: 33px;
  }

  & > .img_blk {
    display: flex;

    & > .ceo_logo {
      width: 180px;
      height: auto;
    }
  }

  & > h3 {
    font-size: 27px;
    margin-top: 37px;
    margin-bottom: 20px;
  }

  & > p {
    color: rgba(0, 0, 0, 0.70);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
  }

  & > video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }

  & > img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  & > .btn {
    width: max-content;
    height: 33px;
    border-radius: 50px;
    border: 1px solid #ddd;
    background: #000;
    color: #fff;
    text-align: center;
    font-family: "Inconsolata", serif;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.77px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding-left: 15px;
    padding-right: 15px;
  }

  @media screen and (orientation: portrait) {
    padding-top: 0;
    margin-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
  }
`;
